export default {
  header: 'Asset parameter definitions',
  subheader: 'This page allows to manage custom asset parameters that may be reused in the signal builder.',
  empty: 'No user defined asset parameters are defined.',
  confirmDelete: {
    header: 'Delete parameter "{parameter}"?',
    message: 'Several assets may use this definition. This can\'t be undone.',
  },
};
